module.exports = __webpack_public_path__ + "media/images/common/menu_tops_ov-805abd1dab1c517e242b12b9681f4163.gif";